import React from 'react'
import { Icon } from '@alicloud/console-components'

const Demo1 = () => ( <Icon type="atm" /> )
export default Demo1;
  export const _demoSrcFiles = __demo_loader_placeholder__